import { Loader } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";
import AdminLayout from "../layouts/AdminLayout";
import StaffLayout from "../layouts/StaffLayout";
import SuperAdminLayout from "../layouts/SuperAdminLayout";

const GetAdminLayout = ({ children }) => {
  const { adminRole, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-white">
        <Loader className="h-8 w-8 animate-spin text-[#f0653a]" />
      </div>
    );
  }

  if (adminRole === "super_admin") {
    return <SuperAdminLayout>{children}</SuperAdminLayout>;
  }

  if (adminRole === "staff") {
    return <StaffLayout>{children}</StaffLayout>;
  }

  if (adminRole === "branch_manager") {
    return <AdminLayout>{children}</AdminLayout>;
  }

  // safety fallback (NEVER null)
  return <>{children}</>;
};

export default GetAdminLayout;

// import { useAdminAuth } from "../context/AdminAuthContext";
// import AdminLayout from "../layouts/AdminLayout";
// import StaffLayout from "../layouts/StaffLayout";
// import SuperAdminLayout from "../layouts/SuperAdminLayout";

// const GetAdminLayout = ({ children }) => {
//   const { adminRole, loading } = useAdminAuth();

//   if (loading) return null;

//   if (adminRole === "super_admin") {
//     return <SuperAdminLayout>{children}</SuperAdminLayout>;
//   }

//   if (adminRole === "staff") {
//     return <StaffLayout>{children}</StaffLayout>;
//   }

//   if (adminRole === "branch_manager") {
//     return <AdminLayout>{children}</AdminLayout>;
//   }

//   // fallback (safety)
//   return null;
// };
// export default GetAdminLayout;
